import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchGroupsPathReference } from '#/modules/search/routing/search.paths';
import type { SearchGroupFiltersByName } from '#/modules/search/types/FiltersByName/SearchGroupFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchGroupsPathByLocale } from './searchGroups.paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchGroupFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetGroupsPath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchGroupsPathReference
    .with(queryParams)
    .replace('/-lang/-segment', searchGroupsPathByLocale[locale]);
}
